export const z0 = 0;
export const z10 = 10;
export const z20 = 20;
export const z30 = 30;
export const z40 = 40;
export const z50 = 50;
//# sourceMappingURL=z-index.js.map